import React, { useEffect, useState } from "react";
import {
  updatePlatformEnabled,
  updatePostTypeSelected,
} from "../../../redux/slices/lomavisCreator/lomavisCreator";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import {
  additonalPlatformIcons,
  PLATFORM_COLORS,
  PLATFORM_ICONS,
} from "../../../config/icons";
import {
  platformFeatures,
  POST_TYPE_KEY,
  showPostTypeSelector,
} from "../config/platformFeatures";
import { Dropdown } from "react-bootstrap";
import { useTranslate } from "@tolgee/react";
import PostTypeDropDown from "./postTypeDropDown";
import toast from "react-hot-toast";
import { validateAllUpload } from "../config/postValidator";
import { ALL } from "../../../config/constants";
import { lomavisCreatorRootState } from "../../../pages/lomavisCreator";
import { getObjectAsFile, updatePlatformStatus } from "../utils/helpers";

interface SelectPlatformToggleProps {
  platform: string;
}

const SelectPlatformToggle: React.FC<SelectPlatformToggleProps> = ({
  platform,
}) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const {
    lomavisCreatorConfig: { connected_platforms, supported_platforms },
    platformEnabled,
    postTypeSelected,
    locationUuid,
    general_post_type,
    cloudUuid,
  } = useSelector((state: any) => state.lomavisCreator);

  const postDataMediaFiles = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.postData?.[ALL]?.media
  );

  const [showDropdown, setShowDropdown] = useState(false);
  const updatePlatformState = async (platform: string, enabled: boolean) => {
    if (!connected_platforms[platform] || !supported_platforms[platform])
      return null;
    if (!platformFeatures[platform]?.[general_post_type] && enabled) {
      toast.error(
        t("LomavisCreator.toastors.post_type_not_supported_for_platform"),
        { position: "top-right" }
      );
      return;
    }

    if (enabled) {
      const prevUploadedFiles = postDataMediaFiles.map((item) =>
        item?.file ? item?.file : getObjectAsFile(item)
      );
      const newEnabledPlatforms = updatePlatformStatus(
        platformEnabled,
        platform,
        enabled
      );

      const is_valid = await validateAllUpload(
        ALL,
        postTypeSelected,
        prevUploadedFiles,
        t,
        dispatch,
        newEnabledPlatforms,
        true
      );

      if (!is_valid) {
        toast.error(
          `${t(`platforms.${platform}`)}: ${t(
            t("lomavisCreator.platform.disabled")
          )}`,
          {
            duration: 4000,
            position: "top-right",
            id: platform,
          }
        );
        return;
      }
    }
    dispatch(updatePlatformEnabled({ platform, enabled }));
  };

  return (
    <div>
      <div className="d-flex flex-column align-items-center flex-grow-1 px-2 mb-2">
        <div
          onClick={() =>
            updatePlatformState(platform, !platformEnabled[platform])
          }
        >
          <div className="border border-secondary d-flex flex-column align-items-center justify-content-between text-center py-5 px-5 rounded cursor-pointer w-70px shadow">
            <div>
              <i
                className={PLATFORM_ICONS[platform] + " fs-2x"}
                style={{
                  color: platformEnabled[platform]
                    ? PLATFORM_COLORS[platform]
                    : null,
                }}
              ></i>
            </div>

            <div
              className="position-absolute"
              style={{ marginLeft: "40px", marginTop: "25px" }}
            >
              {additonalPlatformIcons[platform] && (
                <i className={additonalPlatformIcons[platform]}></i>
              )}
            </div>
          </div>
        </div>

        {platformEnabled[platform] && showPostTypeSelector(platform) && (
          <div className="mt-1 mb-2">
            <PostTypeDropDown platform={platform} />
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectPlatformToggle;
